import API from '../API/newIndex';

/**
 * Fetch blogs list with pagination, search, sorting, and tab filters
 */
export const fetchBlogs = async ({
  page = 1,
  limit = 10,
  searchkey = '',
  sortBy = 'createdAt',
  orderBy = 'DESC',
  openTab = 'all',
  is_draft,
} = {}) => {
  try {
    const trimmedSearch = (searchkey || '').trim();
    const searchParam = trimmedSearch.length >= 3 ? encodeURIComponent(trimmedSearch) : '';
    const tabParam =
      is_draft !== undefined
        ? `&is_draft=${is_draft}`
        : openTab === 'draft'
        ? '&is_draft=true'
        : openTab === 'publish'
        ? '&is_draft=false'
        : '';

    const url = `/admin/blog/getBlogs?page=${page}&limit=${limit}&searchkey=${searchParam}&sort_by=${sortBy}&order_by=${orderBy}${tabParam}`;

    const res = await API({
      url,
      method: 'get',
    });
    return res?.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

/**
 * Fetch a single blog by slug or ID
 */
export const getParticularBlog = async (blogSlug) => {
  try {
    const res = await API({
      url: `/admin/blog/getparticularBlog/${blogSlug}`,
      method: 'get',
    });
    return res?.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

/**
 * Add a new blog
 */
export const addBlog = async (payload) => {
  try {
    const res = await API({
      url: '/admin/blog/addBlog',
      method: 'post',
      data: payload,
    });
    return res;
  } catch (error) {
    return Promise.reject(error);
  }
};

/**
 * Update an existing blog by ID
 */
export const updateBlog = async (id, payload) => {
  try {
    const res = await API({
      url: `/admin/blog/updateBlog/${id}`,
      method: 'put',
      data: payload,
    });
    return res;
  } catch (error) {
    return Promise.reject(error);
  }
};

/**
 * Delete blog(s) by ID array
 */
export const deleteBlogs = async (ids) => {
  try {
    const res = await API({
      url: '/admin/blog/deleteBlog',
      method: 'post',
      data: { id: ids },
    });
    return res;
  } catch (error) {
    return Promise.reject(error);
  }
};

export * from './blogCategoryService';
